import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Modal as BootstrapModal, ModalHeader } from 'reactstrap';
import { bind } from '../Utils/Bind';
import { Deferred } from '../Utils/Deferred';
import { componentAutoReaction } from '../Utils/MobxTools';
import { UserAgent } from '../Utils/UserAgent';

export class PopoutHandle {
    @bind
    @action
    public open() {
        this.isShowing = true;
        this.deferred = new Deferred<boolean>();
    }

    @bind
    @action
    public close() {
        if (!this.deferred) throw new Error('Popout must be open first');

        this.isShowing = false;

        this.opened = false;

        this.deferred.resolve(true);
    }

    @bind
    @action
    public reject() {
        if (!this.deferred) throw new Error('Popout must be open first');

        this.isShowing = false;
        this.deferred.resolve(false);
    }

    @bind
    @action
    public resolve() {
        if (!this.deferred) throw new Error('Popout must be open first');

        this.isShowing = false;
        this.deferred.resolve(true);
    }

    @observable
    public isShowing: boolean = false;

    @observable
    public opened: boolean = false;

    @observable
    public deferred: Deferred<boolean> | undefined;

    @observable
    public popoutRef?: HTMLDivElement;
}

export interface IPopoutProps {
    onOpened?(): void;
    onClosed?(): void;
    bodyRef?(r: HTMLDivElement | null): HTMLDivElement | null;
    readonly popoutHandle: PopoutHandle;
    readonly className?: string;
    readonly lightTheme?: boolean;
    readonly size: 'full' | 'side';
    readonly btnClass?: string;
}

@observer
export class Popout extends React.Component<IPopoutProps> {
    public componentDidMount() {
        componentAutoReaction(this, () => this.props.popoutHandle.isShowing, this.onHandleToggle);
    }

    public render() {
        const {children, className } = this.props;
        return (
            <div className={this.className} ref={this.setRef}>
                <div className="d-flex w-100">
                    <a className="ml-auto btn btn-link-white" onClick={this.onClose}>
                        <BsXCircle />
                    </a>
                </div>

                <div className={className}>{children}</div>
            </div>
        );
    }

    @bind
    @action
    private setRef(ref: HTMLDivElement) {
        this.props.popoutHandle.popoutRef = ref;
    }

    @bind
    private onClose() {
        this.props.popoutHandle.close();
    }

    @bind
    private onHandleToggle(showing: boolean) {
        if (showing) this.onHandleOpened();
        else this.onHandleClosed();
    }

    @bind
    private onHandleOpened() {
        if (this.props.onOpened) this.props.onOpened();
    }

    @bind
    private onHandleClosed() {
        if (this.props.onClosed) this.props.onClosed();
    }
    
    @computed
    private get className() {
        let className = 'popout ';
        if(!this.props.lightTheme) className = className + " popout-dark";
        className = className + (this.props.popoutHandle.isShowing ? ' show ' : ' hide ') + this.props.size;
            
        return className;
    }
}
